module.exports = __webpack_public_path__ + "static/media/coupang.73219c9d.svg";